//Helpers
import { LogError } from "../../../helpers/logger"

export const MicroServices = [
  {
    name: "Appointments",
    envVariable: "REACT_APP_APPOINTMENTS_API",
  },
  {
    name: "Assessments",
    envVariable: "REACT_APP_ASSESSMENTS_API",
  },
  {
    name: "Document Signing",
    envVariable: "REACT_APP_DOCUMENT_SIGNING_API",
  },
  {
    name: "Notifications",
    envVariable: "REACT_APP_NOTIFICATIONS_API",
  },
  {
    name: "Referrals",
    envVariable: "REACT_APP_REFERRALS_API",
  },
  { name: "Tasks", envVariable: "REACT_APP_TASKS_API" },
  {
    name: "Telerecovery",
    envVariable: "REACT_APP_TWILIO_MICROSERVICE_API",
  },
]

export const getURLOverrideValue = (key) => {
  const defaultOverrideValue = {
    overrideUrl: undefined,
  }

  try {
    const storageValue = localStorage.getItem(key)

    if (storageValue) {
      let overrideValue = JSON.parse(storageValue)

      return overrideValue
    } else {
      return defaultOverrideValue
    }
  } catch (error) {
    LogError("Unable to retrieve override URL value from localStorage", error)
    return defaultOverrideValue
  }
}

export const setURLOverrideValue = (key, value) => {
  if (value === "") {
    localStorage.removeItem(key)
  } else {
    const saveValue = JSON.stringify({ overrideUrl: value })

    localStorage.setItem(key, saveValue)
  }
}

export const hasActiveUrlOverrides = () => {
  let hasActive = false

  MicroServices.forEach((service) => {
    if (!hasActive) {
      const override = getURLOverrideValue(
        `${service.envVariable}`
      )
      if (override?.overrideUrl) {
        hasActive = true
      }
    }
  })

  return hasActive
}

export const getActiveURLOverrides = () => {
  let overrides = []

  MicroServices.forEach((service) => {
    const override = getURLOverrideValue(
      `${service.envVariable}`
    )
    if (override?.overrideUrl) {
      overrides = [...overrides, service.name]
    }
  })

  return overrides
}

export const disableAllUrlOverrides = () => {
  let hasActive = false

  MicroServices.forEach((service) => {
    if (!hasActive) {
      const key = `${service.envVariable}`

      const override = getURLOverrideValue(key)
      if (override?.overrideUrl) {
        setURLOverrideValue(key, "")
      }
    }
  })
}
